// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  LIFECYCLE_DATE_LAG_HEX,
  LIFECYCLE_INVOICE_REVIEW_HEX,
} from '@/billing/constants/lifecycle-segment-colors';
import type { CycleTimeSegment } from '@/report/components/cycle-time-metrics';
import type {
  InboundShipmentCycleTimeReport,
  OutboundShipmentCycleTimeReport,
} from '@/shipment/api/types';

type OutboundShipmentCycleTimeMetricKey = keyof Pick<
  OutboundShipmentCycleTimeReport,
  'createdToShipped' | 'shippedToDelivered'
>;

type InboundShipmentCycleTimeMetricKey = keyof Pick<
  InboundShipmentCycleTimeReport,
  'createdToShipped' | 'shippedToDelivered' | 'deliveredToReceived'
>;

export const OUTBOUND_SHIPMENT_CYCLE_TIME_SEGMENTS: CycleTimeSegment<OutboundShipmentCycleTimeMetricKey>[] =
  [
    {
      key: 'createdToShipped',
      label: 'Created to shipped',
      tooltip: 'Time from shipment creation to outbound shipment shipped',
      color: LIFECYCLE_INVOICE_REVIEW_HEX,
    },
    {
      key: 'shippedToDelivered',
      label: 'Shipped to delivered',
      tooltip: 'Time from outbound shipment shipped to delivered',
      color: 'success.main',
    },
  ];

export const INBOUND_SHIPMENT_CYCLE_TIME_SEGMENTS: CycleTimeSegment<InboundShipmentCycleTimeMetricKey>[] =
  [
    {
      key: 'createdToShipped',
      label: 'Created to shipped',
      tooltip: 'Time from shipment creation to inbound shipment shipped',
      color: LIFECYCLE_INVOICE_REVIEW_HEX,
    },
    {
      key: 'shippedToDelivered',
      label: 'Shipped to delivered',
      tooltip: 'Time from inbound shipment shipped to delivered',
      color: 'success.main',
    },
    {
      key: 'deliveredToReceived',
      label: 'Delivered to received',
      tooltip: 'Time from inbound shipment delivered to received',
      color: LIFECYCLE_DATE_LAG_HEX,
    },
  ];
